import { tokenKey } from "@/setup.const";
import Axios from "axios";

export const apiUrl = process.env.VUE_APP_API_URL;

const axiosConfig = (
  header: any = undefined,
  responseType: any = undefined
) => {
  const conf: any = {
    baseURL: apiUrl,
    headers: {
      "x-access-token": localStorage.getItem(tokenKey),
    },
  };

  if (header) {
    conf.headers = { ...conf.headers, ...header };
  }

  if (responseType) {
    conf.responseType = responseType;
  }

  return conf;
};

export const api = (isForm: any = undefined, responseType: any = undefined) => {
  if (isForm) {
    return Axios.create(
      axiosConfig({ "Content-Type": "multipart/form-data" }, responseType)
    );
  }
  return Axios.create(axiosConfig(undefined, responseType));
};

const nextDelivery = { nextDelivery: "account/nextDelivery" };

export const API_ROUTES = {
  mood: { mood: "account/mood" },
  categories: "categories",
  auth: {
    login: "auth/login",
    account: "account",
    forgotPassword: "auth/forgotPassword",
    resetPassword: "auth/resetPassword",
  },
  home: {
    collaboration: "account/collaborations",
    ...nextDelivery,
    blog: "animation/blog",
    novelty: "animation/novelty",
    report: "account/monthly",
    account: "account",
  },
  information: {
    deliveriesAddresses: "account/addresses/deliveries",
    billingsAddresses: "account/addresses/billings",
    quotes: "account/quotes",
    account: "account",
  },
  commands: {
    commands: "account/commands",
    ...nextDelivery,
  },
  invoices: {
    invoices: "account/invoices",
    gocardless: "payment/gocardless/mandate/active",
    quarterlyInvoice: "account/invoices/quarterly-invoices"
  },
  gocardless: {
    mandate: "payment/gocardless/mandate",
  },
  communication: {
    documents: "communication/documents",
    report: "account/monthly",
  },
  rewards: {
    account: "account",
    rewards: "account/rewards",
  },
  share: {
    godchildren: "account/godchildren",
  },

  // admin stuff
  adminAnimation: {
    blog: "animation/blog",
    novelty: "animation/novelty",
  },
  adminDocuments: {
    documents: "communication/documents",
    clients: "clients",
  },
};

export const FORM_ROUTE = {
  home: {
    novelty: "",
    discovery: "",
  },
};
